<template>
  <div class="page-container">
    <div class="main">


      <page :url="url" :form="form" @reset="reset" :axiosType="'post'">
        <template slot="tableSearch" v-if="$store.state.roleId == '1070960390067716097'">

          <el-form-item label="统计维度">
            <el-select v-model="form.statisticsTypeList" multiple placeholder="请选择统计维度" style="width: 300px">
              <el-option v-for="item in statisticsTypeOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>



          <el-form-item label="日期">
            <el-date-picker v-model="timeDate" type="daterange" format="yyyy-MM-dd" value-format="yyyyMMdd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange">
            </el-date-picker>
          </el-form-item>

        </template>



        <template slot="tableColumn">
          <el-table-column prop="statisticsType" width="90px" label="统计维度" align="center"
            :formatter="$formatter.formatStatiscsBankType" />

          <el-table-column prop="dateFormat" width="90px" label="统计日期" align="center" />

          <el-table-column prop="orderCount" width="90px" label="订单总数" align="center" />
          
          <el-table-column prop="usageRateRespList" width="120px" label="第一银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[0]">
                  <el-popover v-if="row.usageRateRespList[0] && row.usageRateRespList[0].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[0].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[0].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[0].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[0]">
                  <el-popover v-if="row.usageRateRespList[0] && row.usageRateRespList[0].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[0].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[0].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[0].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第二银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[1]">
                  <el-popover v-if="row.usageRateRespList[1] && row.usageRateRespList[1].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[1].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[1].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[1].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[1]">
                  <el-popover v-if="row.usageRateRespList[1] && row.usageRateRespList[1].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[1].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[1].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[1].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第三银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[2]">
                  <el-popover v-if="row.usageRateRespList[2] && row.usageRateRespList[2].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[2].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[2].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[2].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[2]">
                  <el-popover v-if="row.usageRateRespList[2] && row.usageRateRespList[2].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[2].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[2].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[2].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第四银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[3]">
                  <el-popover v-if="row.usageRateRespList[3] && row.usageRateRespList[3].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[3].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[3].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[3].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[3]">
                  <el-popover v-if="row.usageRateRespList[3] && row.usageRateRespList[3].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[3].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[3].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[3].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第五银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[4]">
                  <el-popover v-if="row.usageRateRespList[4] && row.usageRateRespList[4].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[4].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[4].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[4].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[4]">
                  <el-popover v-if="row.usageRateRespList[4] && row.usageRateRespList[4].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[4].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[4].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[4].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第六银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[5]">
                  <el-popover v-if="row.usageRateRespList[5] && row.usageRateRespList[5].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[5].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[5].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[5].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[5]">
                  <el-popover v-if="row.usageRateRespList[5] && row.usageRateRespList[5].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[5].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[5].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[5].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第七银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[6]">
                  <el-popover v-if="row.usageRateRespList[6] && row.usageRateRespList[6].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[6].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[6].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[6].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[6]">
                  <el-popover v-if="row.usageRateRespList[6] && row.usageRateRespList[6].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[6].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[6].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[6].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第八银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[7]">
                  <el-popover v-if="row.usageRateRespList[7] && row.usageRateRespList[7].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[7].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[7].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[7].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[7]">
                  <el-popover v-if="row.usageRateRespList[7] && row.usageRateRespList[7].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[7].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[7].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[7].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第九银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[8]">
                  <el-popover v-if="row.usageRateRespList[8] && row.usageRateRespList[8].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[8].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[8].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[8].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[8]">
                  <el-popover v-if="row.usageRateRespList[8] && row.usageRateRespList[8].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[8].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[8].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[8].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="120px" label="第十银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[9]">
                  <el-popover v-if="row.usageRateRespList[9] && row.usageRateRespList[9].bankName.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[9].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[9].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[9].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[9]">
                  <el-popover v-if="row.usageRateRespList[9] && row.usageRateRespList[9].usageRate.length > 10"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[9].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[9].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[9].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="100px" label="第十一银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[10]">
                  <el-popover v-if="row.usageRateRespList[10] && row.usageRateRespList[10].bankName.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[10].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[10].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[10].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[10]">
                  <el-popover v-if="row.usageRateRespList[10] && row.usageRateRespList[10].usageRate.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[10].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[10].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[10].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="100px" label="第十二银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[11]">
                  <el-popover v-if="row.usageRateRespList[11] && row.usageRateRespList[11].bankName.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[11].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[11].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[11].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[11]">
                  <el-popover v-if="row.usageRateRespList[11] && row.usageRateRespList[11].usageRate.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[11].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[11].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[11].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="100px" label="第十三银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[12]">
                  <el-popover v-if="row.usageRateRespList[12] && row.usageRateRespList[12].bankName.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[12].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[12].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[12].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[12]">
                  <el-popover v-if="row.usageRateRespList[12] && row.usageRateRespList[12].usageRate.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[12].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[12].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[12].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>


          <el-table-column prop="usageRateRespList" width="100px" label="第十四银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[13]">
                  <el-popover v-if="row.usageRateRespList[13] && row.usageRateRespList[13].bankName.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[13].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[13].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[13].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[13]">
                  <el-popover v-if="row.usageRateRespList[13] && row.usageRateRespList[13].usageRate.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[13].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[13].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[13].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="usageRateRespList" width="100px" label="第十五银行" align="center">
            <template slot-scope="{ row }">
              <div>
                <div v-if="row.usageRateRespList[14]">
                  <el-popover v-if="row.usageRateRespList[14] && row.usageRateRespList[14].bankName.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[14].bankName">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[14].bankName }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[14].bankName }}</div>
                </div>
                <span v-else>--</span>
              </div>

              <div>
                <div v-if="row.usageRateRespList[14]">
                  <el-popover v-if="row.usageRateRespList[14] && row.usageRateRespList[14].usageRate.length > 8"
                    placement="top-start" width="200" trigger="hover" :content="row.usageRateRespList[14].usageRate">
                    <div slot="reference" class="remark">{{ row.usageRateRespList[14].usageRate }}</div>
                  </el-popover>
                  <div v-else>{{ row.usageRateRespList[14].usageRate }}%</div>
                </div>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

        </template>
      </page>

    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import moment from 'moment'

export default {
  name: 'Systems',
  components: {
    page: Page,
  },
  data() {
    return {
      isShowAgentSelDialog: false,
      formData: null,
      multipleSelection: [],
      strMultipleSelection: [],
      url: '/statistics/bank/getList',
      action: '',
      timeDate: [],
      statisticsTypeOptions: [
        {
          value: 'payInSuccess',
          label: '代收成功',
        },
        {
          value: 'payOutSuccess',
          label: '代付成功',
        },
        {
          value: 'payOutError',
          label: '代付异常',
        }],
      form: {
        statisticsTypeList: ['payInSuccess', 'payOutSuccess', 'payOutError'],
        startDate: '',
        endDate: '',
      },
    }
  },

  created() {
    let start = moment().subtract(7, 'days').format('yyyyMMDD')
    let end = moment().format('yyyyMMDD')
    this.form.startDate = start
    this.form.endDate = end
    this.form.statisticsTypeList = ['payInSuccess', 'payOutSuccess', 'payOutError']
    this.timeDate = [start, end]

    const params = {
      ...this.form
    }

    this.$axios
      .post('/statistics/bank/getList', params)
      .then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '提示',
            message: res.msg,
            type: 'success',
          })
          this.list = res.data.list

        } else {
          this.$notify.error({
            title: '提示',
            message: res.msg,
          })
        }
      })
  },


  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        let start = moment().subtract(7, 'days').format('yyyyMMDD')
        let end = moment().format('yyyyMMDD')
        this.form.startDate = start
        this.form.endDate = end
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD')
      let end = moment().format('yyyyMMDD')
      this.form.startDate = start
      this.form.endDate = end
      this.form.statisticsTypeList = ['payInSuccess', 'payOutSuccess', 'payOutError']
      this.timeDate = [this.form.startDate, this.form.endDate]
    },
  },
}
</script>
<style lang="scss" scoped>

  .remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

</style>